module.exports = __webpack_public_path__ + "static/media/web-login.d654b596.png";